// Carrega as configurações da IA por caixa de entrada (ver AI.md).
import { ref, computed } from 'vue';
import aiAPI from 'dashboard/api/ai';

export function useAiInboxSettings() {
  const settings = ref([]);
  const meta = ref({});
  const isLoading = ref(false);
  const selectedInboxId = ref(null);

  const selectedSetting = computed(() =>
    settings.value.find(setting => setting.inbox_id === selectedInboxId.value)
  );
  const inboxOptions = computed(() =>
    settings.value.map(setting => ({
      value: setting.inbox_id,
      label: setting.inbox_name,
    }))
  );
  const providerConfigured = computed(
    () => meta.value.provider_configured !== false
  );

  const fetchSettings = async () => {
    isLoading.value = true;
    try {
      const { data } = await aiAPI.getInboxSettings();
      settings.value = data.payload;
      meta.value = data.meta || {};
      const stillExists = settings.value.some(
        setting => setting.inbox_id === selectedInboxId.value
      );
      if (!stillExists) {
        const firstEnabled = settings.value.find(setting => setting.enabled);
        selectedInboxId.value = (firstEnabled || settings.value[0])?.inbox_id;
      }
    } finally {
      isLoading.value = false;
    }
  };

  const replaceSetting = updated => {
    settings.value = settings.value.map(setting =>
      setting.inbox_id === updated.inbox_id ? updated : setting
    );
  };

  return {
    settings,
    meta,
    isLoading,
    selectedInboxId,
    selectedSetting,
    inboxOptions,
    providerConfigured,
    fetchSettings,
    replaceSetting,
  };
}
